import React from "react";
import { Controller } from "react-hook-form";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

export const CustomTimePicker = ({
  name,
  control,
  errors,
  validateFn,
  onlyMinutes = false,
  minTime = null,
  maxTime = null,
  shouldDisableTime = undefined,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        rules={{
          validate: validateFn,
        }}
        render={({ field }) => (
          <TimePicker
            ampm={false}
            format="HH:mm"
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            views={onlyMinutes ? ["minutes"] : ["hours", "minutes"]}
            openTo={onlyMinutes ? "minutes" : "hours"}
            {...field}
            value={field.value || null}
            onChange={(newValue) => field.onChange(newValue)}
            minTime={minTime}
            maxTime={maxTime}
            shouldDisableTime={shouldDisableTime}
            slotProps={{
              textField: {
                size: "small",
                error: Boolean(errors[name]),
                helperText: errors[name]?.message,
                fullWidth: true,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
